<div class="container">
  <ul>
    <li>Debe cargar los siguientes documentos obligatorios para continuar.</li>
    <li>Se admiten archivos de formato PNG, JPG, PDF y rar de hasta 5MB.</li>
  </ul>

  <br />
  <!-- TABLA -->
  <ng-container *ngFor="let option of documentsCategory">
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th class="helpText">
            <strong>{{ option.helpText }} </strong>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let doc of option.documents">
          <td style="width: 5rem">
            <mat-icon
              style="color: #0ebc7f"
              *ngIf="doc.scanned && !doc.exceptDocument"
              matTooltip="Se escaneo correctamente"
              >done</mat-icon
            >
            <mat-icon
              style="color: red"
              *ngIf="
                doc.scanned != undefined && !doc.scanned && !doc.exceptDocument
              "
              >clear</mat-icon
            >
          </td>
          <td>{{ doc.name }} (*)</td>
          <td class="buttons-table-position">
            <ng-container *ngIf="doc.spinner; else publish">
              <mat-spinner [diameter]="22"></mat-spinner>
            </ng-container>
            <ng-template #publish>
              <ng-container
                *ngIf="!doc.uploaded || !doc.scanned; else uploaded"
              >
                <button
                  *ngIf="!doc.exceptDocument"
                  mat-icon-button
                  style="color: #0ebc7f"
                  matTooltip="Modelo del documento"
                  (click)="openViewModelDocuments(doc)"
                >
                  <mat-icon>help</mat-icon>
                </button>
                <label
                  mat-icon-button
                  matTooltip="Tomar fotografía"
                  style="color: #0ebc7f; margin-top: 12px"
                  *ngIf="doc.canOpenCamera && cameraMovil"
                  for="{{ doc.id }}-'camera'"
                >
                  <mat-icon style="margin-top: 12px; margin-right: 6px"
                    >camera_alt</mat-icon
                  >
                </label>
                <input
                  type="file"
                  accept="image/*"
                  capture="enviroment"
                  id="{{ doc.id }}-'camera'"
                  (change)="loadDocument($event, doc)"
                  *ngIf="doc.canOpenCamera && cameraMovil"
                  style="display: none"
                />
                <label
                  mat-icon-button
                  matTooltip="Subir documento"
                  for="{{ doc.id }}"
                  style="color: #0ebc7f"
                  *ngIf="canEdit"
                >
                  <mat-icon class="button-upload"> publish</mat-icon>
                </label>
                <input
                  *ngIf="canEdit"
                  type="file"
                  id="{{ doc.id }}"
                  name="avatar"
                  accept="image/png, image/jpeg, application/pdf, .rar"
                  (change)="loadDocument($event, doc)"
                  hidden
                />
              </ng-container>
              <ng-template #uploaded
                ><button
                  mat-icon-button
                  matTooltip="Ver documento"
                  color="primary"
                  (click)="viewDocuments(doc)"
                >
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
                <button
                  *ngIf="doc.delete && canEdit"
                  mat-icon-button
                  matTooltip="Eliminar documento"
                  color="primary"
                  (click)="confirmDeleteDocuments(doc)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
